import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { debounce } from '@roc-digital/mxm-base/logic';
import plugin from 'tailwindcss';
import { el } from 'date-fns/locale';

export interface TextEditorProps {
  onChange: (value: string) => void;
  value: string;
}

export const TextEditor = (props: TextEditorProps) => {
  const [content, setContent] = React.useState('')
  const editorRef = React.useRef<any>(null);
  const lastContent = React.useRef('');

  const onChangeApi = React.useMemo(() => {
    let timeout: any = 0;
    const update = () => {
      if(timeout) clearTimeout(timeout);
      if(props.onChange) {
        const content = editorRef.current.getContent();
        lastContent.current = content;
        props.onChange(lastContent.current);
      }  
    }
    const debounce = () => {
      if(timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        update();
        timeout = null;
      }, 500)
    }
    return {update, debounce};
  }, [])

  React.useEffect(() => {
    if(props.value !== lastContent.current) {
      lastContent.current = props.value;
      setContent(props.value);
    }
  }, [props.value]);

  return (
    <>
      <Editor
        onInit={(evt, editor) => editorRef.current = editor}
        tinymceScriptSrc={"/tinymce/js/tinymce/tinymce.min.js"}
        initialValue={content}
        onChange={onChangeApi.debounce}
        onFocusOut={onChangeApi.update}
        init={{
          height: 500,
          menubar: false,
          extended_valid_elements:'data[value]',
          plugins: [
            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
            'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount',
          ],
          toolbar: 'undo redo | blocks | image | code | ' +
            'bold italic forecolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | link | ' +
            'removeformat | help',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px; }',
          contextmenu: 'copy paste link',
          paste_preprocess: pastePreprocess
        }}
      />
    </>
  );
};

export default TextEditor;

function pastePreprocess(plugin, args) {

  const div = document.createElement('div');

  div.innerHTML = args.content;

  for(let child of div.children) {
    cleanLoop(child, div)
  }

  args.content = div.innerHTML;
}

function cleanLoop(element: Element, parent: Element) {

  if(element.tagName === 'LI') {
    if(element.children.length === 1 && element.children[0].tagName === 'P') {
      element.innerHTML = element.children[0].innerHTML;
    }
  }

  if(element.tagName === 'HR') {
    element.remove();
    return;
  }

  for(let child of element.children) {
    cleanLoop(child, element)
  }
}